import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { X, Cookie } from 'lucide-react';

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Check if user has already consented
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      // Show banner after a short delay
      const timer = setTimeout(() => setVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAcceptAll = () => {
    localStorage.setItem('cookieConsent', JSON.stringify({
      necessary: true,
      analytics: true,
      marketing: true,
      timestamp: new Date().toISOString()
    }));
    setVisible(false);
  };

  const handleAcceptNecessary = () => {
    localStorage.setItem('cookieConsent', JSON.stringify({
      necessary: true,
      analytics: false,
      marketing: false,
      timestamp: new Date().toISOString()
    }));
    setVisible(false);
  };

  const handleClose = () => {
    // Accept necessary only when closing
    handleAcceptNecessary();
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 animate-in slide-in-from-bottom duration-300">
      <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-2xl border border-slate-200 overflow-hidden">
        <div className="p-4 md:p-6">
          <div className="flex items-start gap-4">
            <div className="h-10 w-10 bg-orange-100 rounded-full flex items-center justify-center shrink-0">
              <Cookie className="h-5 w-5 text-orange-500" />
            </div>
            <div className="flex-1">
              <div className="flex items-start justify-between gap-4">
                <div>
                  <h3 className="font-semibold text-slate-900 text-lg">We Value Your Privacy</h3>
                  <p className="text-slate-600 text-sm mt-1">
                    We use cookies to enhance your browsing experience, analyze site traffic, and personalize content. 
                    By clicking "Accept All", you consent to our use of cookies. You can also choose to accept only 
                    necessary cookies for basic site functionality.
                  </p>
                  <p className="text-sm mt-2">
                    <Link to="/privacy" className="text-orange-500 hover:underline">
                      Read our Privacy Policy
                    </Link>
                  </p>
                </div>
                <button 
                  onClick={handleClose}
                  className="p-1 hover:bg-slate-100 rounded shrink-0"
                  aria-label="Close cookie banner"
                >
                  <X className="h-5 w-5 text-slate-400" />
                </button>
              </div>
              
              <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 mt-4">
                <Button
                  onClick={handleAcceptAll}
                  className="rounded-sm bg-orange-500 hover:bg-orange-600"
                >
                  Accept All Cookies
                </Button>
                <Button
                  onClick={handleAcceptNecessary}
                  variant="outline"
                  className="rounded-sm"
                >
                  Accept Necessary Only
                </Button>
                <Link to="/privacy" className="hidden sm:block">
                  <Button variant="ghost" className="rounded-sm text-slate-500">
                    Cookie Settings
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
